import React from "react";
import { Wrapper, Row } from "./styled";
import NomenclatureData from "./components/NomenclatureData";
import PlanData from "./components/PlanData";
import RealStateDenomination from "./components/RealStateDenomination";
import Registration from "./components/Registration";
import Value from "./components/Value";
import RealStateTax from "./components/RealStateTax";
import Location from "./components/Location";
import PlotDepartureObservations from "./components/PlotDepartureObservations";
import CadastralBoundary from "./components/CadastralBoundary";
import FractionDenomination from "./components/FractionDenomination";

const RecoveredData = ({ selectedPlot }) => {
  return (
    <Wrapper>
      <NomenclatureData selectedPlot={selectedPlot} />
      <PlanData selectedPlot={selectedPlot} />
      <RealStateDenomination selectedPlot={selectedPlot} />
      <CadastralBoundary />
      <Value selectedPlot={selectedPlot} />
      <Row>
        <Registration selectedPlot={selectedPlot} />
        <RealStateTax selectedPlot={selectedPlot} />
      </Row>
      <Row>
        <Location selectedPlot={selectedPlot} />
      </Row>
      <PlotDepartureObservations selectedPlot={selectedPlot} />
      <FractionDenomination />
    </Wrapper>
  );
};

export default RecoveredData;
